import { selectActiveIndividual } from '../state/HUDSlice';
import { useSelector } from 'react-redux';

const useHUDIndividual = () => useSelector(selectActiveIndividual);

export default useHUDIndividual;
